<div class="page-header">
  <h2>Relatório</h2>

  @if (selectedURL.exportType === exportType.pdf) {
    <button class="btn danger__no-bg" (click)="exportToPdf()">
      Exportar em PDF
    </button>
  } @else if (selectedURL.exportType === exportType.excel) {
    <button class="btn danger__no-bg" (click)="exportToExcel()">
      Exportar em Excel
    </button>
  }
</div>

<div class="card">
  <div class="menu">
  @for (url of urls; track url.url) {
    <p
      routerLinkActive="active"
      [routerLink]="url.url"
      (click)="selectedURL = url"
      *allowed="url.permissions"
    >
      {{ url.title }}
    </p>
  }
</div>
  <button class="btn danger__no-bg" (click)="openFilterDialog()">
    Filtros
  </button>
</div>

<div id="exportToPDF">
  <router-outlet/>
</div>
